//#Global Imports
import React from "react";
import clsx from "clsx";
//#end Global Imports

//#Local Imports
import ErrorField from "../../../../components/ui/ErrorField";
import TextField from "../../../../components/ui/TextField";
import Button from "../../../../components/ui/Button";
import { PassportIcon, ReloadIcon, UploadIcon } from "../../../../assets/Icons";
import IUserDocuments from "../../userDocuments";
//#end Local Imports

const VoterIdCardSection: React.FC<IUserDocuments.IVoterIdCardSectionProps> = ({
  voterIDCardDetails,
  handleDeleteDoc,
  handleChangeUpload,
  setVoterIDCardDetails,
  handleEVerifyVoterCard,
  buttonLoader,
}) => {
  return (
    <div className="col-span-4 lg:pl-10 lg:pt-7">
      <div>
        <div className="mb-5 text-base font-medium text-black font-lato">
          Upload Voter ID<span className="text-error">*</span>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  voterIDCardDetails.isVIDocVerified || voterIDCardDetails.isVoterFrontUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full mb-5 h-[68px] lg:!w-[48%]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      voterIDCardDetails.isVIDocVerified || voterIDCardDetails.isVoterFrontUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload Voter ID front page</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!voterIDCardDetails.isVIDocVerified &&
                    !voterIDCardDetails?.isVoterBackUploaded &&
                    (voterIDCardDetails.isVoterFrontUploaded ? (
                      <div
                        onClick={
                          !voterIDCardDetails.isVIDocVerified &&
                          voterIDCardDetails.isVoterFrontUploaded
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-secondary-600" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {voterIDCardDetails.uploadedDocError !== "" && (
            <ErrorField errorMessage={voterIDCardDetails.uploadedDocError} />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="VOTER_ID_FRONT"
              type="file"
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              disabled={voterIDCardDetails.isVoterFrontUploaded}
              onChange={(e) => {
                handleChangeUpload(e, "VOTER_CARD");
              }}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  voterIDCardDetails.isVIDocVerified || voterIDCardDetails.isVoterBackUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full mb-5 h-[68px] lg:!w-[48%]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      voterIDCardDetails.isVIDocVerified || voterIDCardDetails.isVoterBackUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload Voter ID back page</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!voterIDCardDetails.isVIDocVerified &&
                    (voterIDCardDetails.isVoterBackUploaded ? (
                      <div
                        onClick={
                          !voterIDCardDetails.isVIDocVerified &&
                          voterIDCardDetails.isVoterBackUploaded
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-secondary-600" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="VOTER_ID_BACK"
              type="file"
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              disabled={
                voterIDCardDetails.isVoterBackUploaded || !voterIDCardDetails.isVoterFrontUploaded
              }
              onChange={(e) => {
                setVoterIDCardDetails((preValue) => {
                  return {
                    ...preValue,
                    voterBackCardFile: URL.createObjectURL(e.target.files[0]),
                    isVoterBackUploaded: true,
                    VoterIdBackImageFileName: e.target.files[0].name,
                  };
                });
              }}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="mb-5 text-base font-medium text-black font-lato">
          Voter Card ID<span className="text-error">*</span>
        </div>
        <TextField
          name="voterCardID"
          type="text"
          placeholderStyle="!text-primary-850"
          inputClasses={clsx(
            voterIDCardDetails.isVIDocVerified ? "border-success-150" : "border-grey-150",
            "border !h-[60px] !top-[0.85rem] !pt-0 lg:!w-[48%]"
          )}
          value={voterIDCardDetails?.isVoterFrontUploaded ? voterIDCardDetails.voterNumber : ""}
          errorMessage={voterIDCardDetails.messageVIVerify}
          error={voterIDCardDetails.messageVIVerify !== ""}
          disabled={!voterIDCardDetails?.isVoterFrontUploaded}
          onChange={(event) =>
            setVoterIDCardDetails((preValue: any) => {
              return {
                ...preValue,
                voterNumber: event.target.value,
              };
            })
          }
          fullWidth
          pattern="[a-zA-Z0-9 ]{1,}"
        />
        {!voterIDCardDetails.isVIDocVerified && (
          <Button
            bgColor={
              voterIDCardDetails.isVoterFrontUploaded && voterIDCardDetails.isVoterBackUploaded
                ? "bg-primary"
                : "bg-grey-350"
            }
            fontStyle={{
              fontFamily: "",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            className={"py-5 w-full mt-9 lg:!w-[48%]"}
            disabled={
              !voterIDCardDetails.isVoterFrontUploaded || !voterIDCardDetails.isVoterBackUploaded
            }
            onClickHandler={handleEVerifyVoterCard}
            isLoading={buttonLoader.eVerifyVoterCard}
          >
            Verify
          </Button>
        )}
      </div>
    </div>
  );
};

export default VoterIdCardSection;
